import React from 'react';
import { CARD, INPUT, LABEL } from './txStyles';

/* The saved record's party, read-only (user, 2026-11-02): when a sale / purchase / refund is
 * opened, the customer / vendor / shop it was with — and its date and description — stay on
 * screen, disabled, instead of the input card disappearing. `items` = [{label, value}]; empty
 * values show "—". Used by the screens whose entry card is hidden once a record is saved. */
export default function RecordParty({ items }) {
    const shown = (items || []).filter(Boolean);
    if (!shown.length) return null;
    const cols = shown.length >= 3 ? '2fr 1fr 2fr' : shown.map(() => '1fr').join(' ');
    return (
        <div style={{ ...CARD, padding: 20, marginBottom: 16 }}>
            <div className="pc-form-grid" style={{ display: 'grid', gridTemplateColumns: cols, gap: 16 }}>
                {shown.map((it, i) => (
                    <div key={i}>
                        <label style={LABEL}>{it.label}</label>
                        <input
                            style={{ ...INPUT, background: '#f1f5f9', cursor: 'not-allowed' }}
                            value={it.value === undefined || it.value === null || it.value === '' ? '—' : String(it.value)}
                            disabled
                            readOnly
                            aria-label={it.label}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}
